import { useState, useCallback } from 'react';
import { GetAllPromotions, getAllReviews, SendReviewRequest } from '../services/api/methods.ts';
import { GetAllPromotionsResult, Promotion, Review, CreateReviewRequestCommand } from '../services/api/types.ts';

export const useReviewRequest = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const sendReviewRequest = useCallback(async (command: CreateReviewRequestCommand) => {
        setLoading(true);
        setError('');

        try {
            await SendReviewRequest(command);
        } catch (err: any) {
            const errorMessage = err.response?.data?.[0]?.message || err.message || 'Ошибка сервера';
            setError(errorMessage);
            console.error(err.response?.data || err);
            throw err;
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        loading,
        error,
        sendReviewRequest,
        setError
    };
};
